/**
 * Coalesce external-store notifications to a max rate (trailing edge).
 * Used for canvas adornments that do not need 60Hz React updates.
 */
export function subscribeThrottled(
  onStoreChange: () => void,
  intervalMs: number,
  subscribeSources: Array<(notify: () => void) => () => void>
): () => void {
  let lastNotifyMs = 0;
  let timer: ReturnType<typeof setTimeout> | null = null;

  const notify = () => {
    const elapsed = performance.now() - lastNotifyMs;
    if (elapsed >= intervalMs) {
      lastNotifyMs = performance.now();
      onStoreChange();
      return;
    }
    if (timer != null) return;
    timer = setTimeout(() => {
      timer = null;
      lastNotifyMs = performance.now();
      onStoreChange();
    }, intervalMs - elapsed);
  };

  const unsubs = subscribeSources.map((subscribe) => subscribe(notify));
  return () => {
    if (timer != null) clearTimeout(timer);
    for (const unsub of unsubs) unsub();
  };
}
